import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = {
  key: 1,
  class: "h-full"
}
const _hoisted_2 = { class: "flex flex-row justify-between items-center border-b border-gray-lp-400" }
const _hoisted_3 = { class: "flex flex-row my-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-20px mr-4 text-black-lp-200" }, " Edit Embargo ", -1)
const _hoisted_5 = { class: "inline-flex" }
const _hoisted_6 = { class: "flex flex-row h-full" }
const _hoisted_7 = { class: "w-2/3 px-4 text-12px xxl:text-14px overflow-y-auto pb-24" }
const _hoisted_8 = { class: "pt-4" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "py-2 text-20px text-gray-lp-300 font-semibold" }, " Detail Embargo ", -1)
const _hoisted_10 = { class: "py-3 w-3/4" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Nama Embargo", -1)
const _hoisted_12 = { class: "inline-block relative w-full my-2 mr-4" }
const _hoisted_13 = { class: "py-3 w-3/4 max-w-full" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 pb-2" }, "Kota Asal", -1)
const _hoisted_15 = { class: "py-3 w-3/4" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 pb-2" }, "Destinasi", -1)
const _hoisted_17 = { class: "py-3 w-3/4" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 pb-2" }, " Tipe Pengiriman ", -1)
const _hoisted_19 = { class: "mt-4 pt-4 border-t border-gray-lp-400" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "py-2 text-20px text-gray-lp-300 font-semibold" }, " Detail Produk ", -1)
const _hoisted_21 = { class: "py-3 w-3/4" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 pb-2" }, " Produk Pengiriman ", -1)
const _hoisted_23 = { class: "py-3 w-3/4" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 pb-2" }, " Komoditas Pengiriman ", -1)
const _hoisted_25 = { class: "py-3 w-3/4" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 pb-2" }, [
  /*#__PURE__*/_createTextVNode(" Berat Maksimal "),
  /*#__PURE__*/_createVNode("span", { class: "text-gray-lp-500 font-normal" }, "(Optional)")
], -1)
const _hoisted_27 = { class: "w-1/3" }
const _hoisted_28 = { class: "mt-4 pt-4 border-t border-gray-lp-400" }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "py-2 text-20px text-gray-lp-300 font-semibold" }, " Periode Embargo ", -1)
const _hoisted_30 = { class: "w-3/5 py-3" }
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row" }, [
  /*#__PURE__*/_createVNode("div", { class: "w-13/20 mr-4" }, [
    /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 mb-2" }, " Dimulai Dari ")
  ])
], -1)
const _hoisted_32 = { class: "text-red-lp-100 text-12px xxl:text-14px whitespace-no-wrap" }
const _hoisted_33 = { class: "w-3/5 py-3" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row" }, [
  /*#__PURE__*/_createVNode("div", { class: "w-13/20 mr-4" }, [
    /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 mb-2" }, " Sampai ")
  ])
], -1)
const _hoisted_35 = { class: "text-red-lp-100 text-12px xxl:text-14px whitespace-no-wrap" }
const _hoisted_36 = { class: "w-1/3 px-8 text-12px xxl:text-14px border-l border-gray-lp-400" }
const _hoisted_37 = { class: "py-3" }
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Status Embargo ", -1)
const _hoisted_39 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal" }
const _hoisted_40 = { class: "flex" }
const _hoisted_41 = { class: "capitalize" }
const _hoisted_42 = { class: "py-3" }
const _hoisted_43 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Tanggal Dibuat ", -1)
const _hoisted_44 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal" }
const _hoisted_45 = { class: "text-gray-lp-500" }
const _hoisted_46 = { class: "py-3" }
const _hoisted_47 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Terakhir Diubah ", -1)
const _hoisted_48 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal" }
const _hoisted_49 = { class: "text-gray-lp-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DatePickerV2 = _resolveComponent("DatePickerV2")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, {
          key: 0,
          onBack: _ctx.goBack
        }, null, 8, ["onBack"]))
      : (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("img", {
                src: _imports_0,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
                class: "w-5 mr-3 cursor-pointer",
                alt: "back"
              }),
              _hoisted_4
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_button_fill, {
                title: "Simpan",
                onClick: _ctx.onOpenSave,
                class: "px-8 bg-red-lp-300",
                isDisabled: _ctx.isDisabled
              }, null, 8, ["onClick", "isDisabled"])
            ])
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode("div", _hoisted_12, [
                    _withDirectives(_createVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.detailData.embargo_name = $event)),
                      onInput: _cache[3] || (_cache[3] = e => _ctx.setEmbargoName(e.target.value)),
                      class: "block appearance-none text-12px xxl:text-14px w-full text-black-lp-300 bg-white border border-gray-lp-400 px-4 py-2 pr-16 rounded shadow leading-tight focus:outline-none",
                      maxlength: 56,
                      placeholder: "Masukkan nama aktivitas upload"
                    }, null, 544), [
                      [_vModelText, _ctx.detailData.embargo_name]
                    ]),
                    _createVNode("div", {
                      class: "cursor-pointer absolute inset-y-0 right-0 flex items-center px-2 text-gray-lp-500 mr-2 text-12px",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onClear && _ctx.onClear(...args)))
                    }, _toDisplayString(_ctx.embargoName.length) + "/56 ", 1)
                  ])
                ]),
                _createVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode(_component_MultipleSelectSearch, {
                    options: _ctx.originCityListData,
                    modelValue: this.detailData.origin_detail,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (this.detailData.origin_detail = $event)),
                    modalTitle: "Kota Asal",
                    keyName: "name",
                    keyValue: "code",
                    isLoading: _ctx.isLoadingOriginCity,
                    placeholder: "Ketik atau pilih kota asal",
                    onFilter: _ctx.fetchOriginCity
                  }, null, 8, ["options", "modelValue", "isLoading", "onFilter"])
                ]),
                _createVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode(_component_MultipleSelectSearch, {
                    options: _ctx.destinationCityListData,
                    modelValue: this.detailData.destination_detail,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (this.detailData.destination_detail = $event)),
                    modalTitle: "Destinasi",
                    keyName: "name",
                    keyValue: "code",
                    isLoading: _ctx.isLoadingDestinationCity,
                    placeholder: "Ketik atau pilih destinasi",
                    onFilter: _ctx.fetchDestinationCity
                  }, null, 8, ["options", "modelValue", "isLoading", "onFilter"])
                ]),
                _createVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode(_component_MultipleSelectSearch, {
                    options: _ctx.typeListData,
                    modelValue: _ctx.typeExclude,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.typeExclude = $event)),
                    modalTitle: "Tipe Pengiriman",
                    keyName: "name",
                    keyValue: "value",
                    placeholder: "Ketik atau pilih tipe pengiriman"
                  }, null, 8, ["options", "modelValue"])
                ])
              ]),
              _createVNode("div", _hoisted_19, [
                _hoisted_20,
                _createVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createVNode(_component_MultipleSelectSearch, {
                    options: _ctx.productListData,
                    modelValue: this.detailData.product_type_detail,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (this.detailData.product_type_detail = $event)),
                    modalTitle: "Produk Pengiriman",
                    keyName: "product_type_code",
                    keyValue: "product_type_code",
                    isLoading: _ctx.isLoadingProduct,
                    placeholder: "Ketik atau pilih produk pengiriman",
                    onFilter: _ctx.fetchProduct
                  }, null, 8, ["options", "modelValue", "isLoading", "onFilter"])
                ]),
                _createVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createVNode(_component_MultipleSelectSearch, {
                    options: _ctx.commodityListData,
                    modelValue: this.detailData.commodity_type_detail,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (this.detailData.commodity_type_detail = $event)),
                    modalTitle: "Komoditas Pengiriman",
                    keyName: "commodity_name",
                    keyValue: "commodity_id",
                    isLoading: _ctx.isLoadingCommodity,
                    placeholder: "Ketik atau pilih komoditas pengiriman",
                    onFilter: _ctx.fetchCommodity
                  }, null, 8, ["options", "modelValue", "isLoading", "onFilter"])
                ]),
                _createVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createVNode("div", _hoisted_27, [
                    _createVNode(_component_LpInput, {
                      modelValue: _ctx.detailData.max_weight,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.detailData.max_weight = $event)),
                      placeholder: "Berat maksimal",
                      suffix: "Kg"
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_28, [
                _hoisted_29,
                _createVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createVNode(_component_DatePickerV2, {
                    modelValue: _ctx.periodeStart,
                    modelValueTime: _ctx.periodeStartTime,
                    onSelected: _ctx.inputDateStart,
                    minDate: _ctx.minDatePeriodeStart,
                    disabled: true,
                    showTimePicker: "",
                    class: "my-2"
                  }, null, 8, ["modelValue", "modelValueTime", "onSelected", "minDate"]),
                  _withDirectives(_createVNode("span", _hoisted_32, "Tanggal mulai tidak boleh lebih atau sama dengan tanggal akhir", 512), [
                    [_vShow, _ctx.invalidStartDate]
                  ])
                ]),
                _createVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _createVNode(_component_DatePickerV2, {
                    modelValue: _ctx.periodeEnd,
                    modelValueTime: _ctx.periodeEndTime,
                    onSelected: _ctx.inputDateEnd,
                    onSelectedTime: _ctx.inputDateEndTime,
                    minDate: _ctx.minDatePeriodeEnd,
                    disabled: _ctx.invalidStartDate,
                    showTimePicker: "",
                    class: "my-2"
                  }, null, 8, ["modelValue", "modelValueTime", "onSelected", "onSelectedTime", "minDate", "disabled"]),
                  _withDirectives(_createVNode("span", _hoisted_35, "Tanggal akhir tidak boleh kurang atau sama dengan tanggal mulai", 512), [
                    [_vShow, _ctx.invalidEndDate]
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_36, [
              _createVNode("div", _hoisted_37, [
                _hoisted_38,
                _createVNode("div", _hoisted_39, [
                  _createVNode("div", _hoisted_40, [
                    _createVNode("div", {
                      class: 
                  `rounded-full px-2 py-0 font-medium ${
                    _ctx.detailData.status.toLowerCase() === 'active'
                      ? 'bg-green-lp-300'
                      : _ctx.detailData.status.toLowerCase() === 'expired'
                      ? 'bg-red-lp-600'
                      : 'bg-yellow-lp-200'
                  } ${
                    _ctx.detailData.status.toLowerCase() === 'active'
                      ? 'text-green-lp-200'
                      : _ctx.detailData.status.toLowerCase() === 'expired'
                      ? 'text-red-lp-500'
                      : 'text-yellow-lp-100'
                  }`
                
                    }, [
                      _createVNode("span", _hoisted_41, _toDisplayString(_ctx.detailData.status.toLowerCase() === "pending"
                      ? "Upcoming"
                      : _ctx.detailData.status.toLowerCase() === "expired"
                      ? "Inactive"
                      : "Active"), 1)
                    ], 2)
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_42, [
                _hoisted_43,
                _createVNode("div", _hoisted_44, _toDisplayString(_ctx.formatDate(_ctx.detailData.created_at)), 1),
                _createVNode("div", _hoisted_45, _toDisplayString(_ctx.detailData.created_by), 1)
              ]),
              _createVNode("div", _hoisted_46, [
                _hoisted_47,
                _createVNode("div", _hoisted_48, _toDisplayString(_ctx.formatDate(_ctx.detailData.updated_at || _ctx.detailData.created_at)), 1),
                _createVNode("div", _hoisted_49, _toDisplayString(_ctx.detailData.updated_by || _ctx.detailData.created_by), 1)
              ])
            ])
          ])
        ])),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.goBack,
      title: "Perubahan Disimpan",
      message: `Rute embargo “${_ctx.embargoName}” berhasil diubah`,
      image: "image-modal-success",
      textSuccess: "Oke",
      class: "px-8"
    }, null, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.openSuccess]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: "Yakin ingin keluar?",
      message: "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx._onEdit,
      onClose: _ctx.onCloseSave,
      title: "Konfirmasi Perubahan Rute Embargo",
      message: 
      `Anda yakin akan menyimpan perubahan untuk rute embargo Anda yakin akan menyimpan perubahan untuk   rute embargo “${_ctx.embargoName}”`
    ,
      image: "are-you-sure",
      textSuccess: "Simpan",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "message"]), [
      [_vShow, _ctx.openSave]
    ])
  ], 64))
}